export class StepDataAnswer {
  answer;
  date;

  constructor(answer, date) {
    this.answer = answer;
    this.date = date;
  }

  asTrendObject() {
    return { date: this.date, value: this.answer };
  }
}
